module.exports = __webpack_public_path__ + "static/media/charli.31ea1c2e.jpg";